import { useMutation } from 'react-query';
import { refreshMarketCompetitorsForAdmin } from '../api/MarketsEndpoints';

export const useRefreshMarketCompetitorsForAdmin = () =>
  useMutation(refreshMarketCompetitorsForAdmin);
